import type { AiAppCenterModule } from '../types'

export const mallModule: AiAppCenterModule = {
  key: 'mall',
  label: '电商系统工作台',
  desc: '商品管理 / 订单处理 / 营销活动',
  path: '/mall',
  homePath: '/mall/overview',
  homeTitles: ['概况', '商城经营概况', '商城首页'],
  icon: 'ep:shop',
  color: '#ef4444',
  aliases: ['商城管理', '商城中心'],
  // 装修入口已迁工作台「商城装修」；独立窗侧栏不再展示
  hiddenStandaloneMenuTitles: ['商城装修']
}
